import type { GridSortModel } from '@mui/x-data-grid';
import { defaultSortModel } from '../config';

export const getSortModel = (sortModel: GridSortModel): GridSortModel => {
  if (sortModel.length === 0 || sortModel[0]?.field !== 'tax_year') return sortModel;
  return sortModel[0].sort === 'desc'
    ? defaultSortModel
    : defaultSortModel.map(item => ({ ...item, sort: 'asc' }));
};
